import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Check, ShieldCheck, Clock, BadgeCheck, Globe } from 'lucide-react';
import { Button } from './Button';
import { CHECKOUT_URL } from '../data/checkout';
export function Pricing() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 4,
    minutes: 59,
    seconds: 0
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            ...prev,
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <section id="precio" className="py-10 md:py-20 bg-stone-50" data-id="element-104" data-mp="3vzymyh8jx933">
      <div className="container mx-auto px-4 md:px-6" data-id="element-105" data-mp="3w1t6ps836v5l">
        {/* ===== MAIN CARD — Orden Financiero™ ===== */}
        <div className="max-w-md mx-auto" data-id="element-106" data-mp="9s8q0vlwzc5h">
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="bg-white rounded-2xl md:rounded-3xl shadow-2xl overflow-hidden border border-gray-100 relative" data-id="element-107" data-mp="9tjukxn6onxn">
            <div className="bg-teal-600 p-3 md:p-6 text-center text-white" data-id="element-108" data-mp="3n6d8z047nvuq">
              <h2 className="font-display text-lg md:text-2xl font-extrabold tracking-tight mb-0.5 md:mb-2" data-id="element-109" data-mp="3ry3kvaisqro9">
                ORDEN FINANCIERO™
              </h2>
              <p className="opacity-90 text-[10px] md:text-sm" data-id="element-110" data-mp="2ugmzx5hfrk5h">
                El sistema digital para tomar el control de tus finanzas
                personales
              </p>
            </div>

            <div className="px-4 md:px-10 pt-3 md:pt-8 pb-5 md:pb-10" data-id="element-111" data-mp="2reicumh2ovtt">
              {/* Product Image */}
              <div className="mb-2 flex justify-center" data-id="element-112" data-mp="316o948ecxzet">
                <img src="https://cdn.magicpatterns.com/uploads/aCbGv9Ta8whf6nYMwBmm7G/Logos_Verduleria_y_Fruteria_Simple_Verde_20260119_022532_0000.png" alt="Orden Financiero™ en múltiples dispositivos" className="w-full max-w-[240px] md:max-w-none h-auto" data-id="element-113" data-mp="3164v32rtvv62" />
              </div>

              {/* Countdown Timer */}
              <div className="mb-2 md:mb-6 bg-red-50 border border-red-100 rounded-lg p-1.5 md:p-3 flex items-center justify-center gap-1 md:gap-2 text-red-700 text-[10px] md:text-sm font-medium" data-id="element-114" data-mp="2igy5qwwj45ba">
                <Clock className="w-3 h-3 md:w-4 md:h-4" data-id="element-115" data-mp="3tu0lxqupusux" />
                <span data-id="element-116" data-mp="3owilypyofnz2">La oferta termina en:</span>
                <span className="font-mono font-bold text-xs md:text-base" data-id="element-117" data-mp="3ovqotapfli6o">
                  {String(timeLeft.hours).padStart(2, '0')}:
                  {String(timeLeft.minutes).padStart(2, '0')}:
                  {String(timeLeft.seconds).padStart(2, '0')}
                </span>
              </div>

              {/* Price */}
              <div className="flex flex-col items-center mb-3 md:mb-8" data-id="element-118" data-mp="3rgor30z11kh7">
                <span className="text-gray-400 line-through text-sm md:text-xl mb-0.5" data-id="element-119" data-mp="3rgyh2ok2nrmw">
                  USD 47
                </span>
                <div className="flex items-baseline gap-1.5" data-id="element-120" data-mp="nzopmizms82f">
                  <span className="font-display text-gray-500 font-bold text-base md:text-2xl" data-id="element-121" data-mp="nz6iusfcebg9">
                    USD
                  </span>
                  <span className="font-display text-5xl md:text-7xl font-extrabold text-gray-900 tracking-tight leading-none tabular-nums" data-id="element-122" data-mp="e9mzzmrmqhle">
                    9,90
                  </span>
                </div>
                <span className="inline-flex items-center gap-1.5 mt-2 px-3 py-1 rounded-full bg-teal-600 text-white text-[10px] md:text-xs font-bold" data-id="element-123" data-mp="16qpkautpxhg6">
                  <Globe className="w-3 h-3 md:w-3.5 md:h-3.5" data-id="element-124" data-mp="3f5fnj3tuj39t" />
                  Paga en tu moneda local
                </span>
                <span className="inline-block mt-1.5 md:mt-4 px-2.5 py-0.5 md:py-1 bg-teal-50 text-teal-700 text-[9px] md:text-xs font-bold rounded-full uppercase tracking-wide" data-id="element-125" data-mp="3592veady8xh6">
                  Pago único · Sin suscripciones
                </span>
                <span className="inline-block mt-1 px-2.5 py-0.5 md:py-1 bg-stone-100 text-stone-600 text-[9px] md:text-xs font-bold rounded-full uppercase tracking-wide" data-id="element-126" data-mp="1rucrobedtle">
                  Acceso inmediato · Acceso de por vida
                </span>
                <p className="mt-2 text-center text-[11px] md:text-sm text-gray-600 leading-snug" data-id="element-127" data-mp="3k74x0f1f78vs">
                  Acceso inmediato. Un solo pago, para toda la vida. Sin
                  suscripciones mensuales.
                </p>
              </div>

              {/* Features */}
              <ul className="space-y-1.5 md:space-y-3 mb-3 md:mb-5" data-id="element-128" data-mp="1yf52ggz5qs1n">
                {['Sistema completo en Google Sheets', 'Control de ingresos, gastos y presupuesto', 'Ahorros, objetivos y gestión de deudas', 'Resúmenes y gráficos automáticos', 'Video Tutorial Paso a Paso', 'Acceso de por vida'].map((item, index) => <li key={index} className="flex items-start gap-2 md:gap-3" data-id="element-129" data-mp="2hdhkytbyle9w" data-mpi={index}>
                    <Check className="w-3.5 h-3.5 md:w-5 md:h-5 text-teal-600 flex-shrink-0 mt-0.5" data-id="element-130" data-mp="2mc2b1zxhyhkm" />
                    <span className="text-gray-700 text-xs md:text-base" data-id="element-131" data-mp="2r4vg6owvnrx8">
                      {item}
                    </span>
                  </li>)}
              </ul>

              {/* Bonuses summary */}
              <div className="border-t border-dashed border-gray-200 pt-3 mb-4 md:mb-6" data-id="element-132" data-mp="306bpetbyhnzv">
                <p className="text-[11px] md:text-sm font-bold text-teal-700 mb-1" data-id="element-133" data-mp="3543friwyd21y">
                  + 5 BONUS EXCLUSIVOS INCLUIDOS
                </p>
                <p className="text-[10px] md:text-xs text-gray-500 leading-snug" data-id="element-134" data-mp="102ivn545osae">
                  Tracker de Deudas · Calendario de Pagos · Fondo de Emergencia
                  · Planificador Mensual · Desafío 30 Días
                </p>
              </div>

              <Button href={CHECKOUT_URL} fullWidth className="mb-2 md:mb-4 !py-4 !text-sm md:!text-base !font-bold" data-id="element-135" data-mp="19yc8kplsensp">
                SÍ, QUIERO ORDENAR MIS FINANZAS HOY
              </Button>

              <p className="text-center text-[11px] md:text-sm text-gray-500 mb-3" data-id="element-136" data-mp="1xq9ha7txwzpl">
                Pago único · Sin cargos mensuales
              </p>

              {/* Price justification */}
              <p className="text-center text-[11px] md:text-sm text-gray-600 leading-snug mb-3" data-id="element-137" data-mp="3b6zyxf1onxr">
                Cuesta menos que esa suscripción que no usas, pero te ayuda a
                cancelar todas las que no necesitas. Se paga solo en la primera
                semana.
              </p>

              {/* Guarantee */}
              <div className="bg-teal-50 border border-teal-100 rounded-xl p-3 mb-3 flex items-start gap-2 text-left" data-id="element-138" data-mp="2eyso7wg279a5">
                <BadgeCheck className="w-4 h-4 md:w-5 md:h-5 text-teal-600 flex-shrink-0 mt-0.5" data-id="element-139" data-mp="208cz46kivh6p" />
                <p className="text-[11px] md:text-sm text-teal-900 leading-snug" data-id="element-140" data-mp="257fsgtr53yyu">
                  <span className="font-bold" data-id="element-141" data-mp="1r8g4lobgbo3q">Garantía de Claridad:</span> si en
                  7 días no tienes una visión más clara de tu dinero, te
                  devolvemos tu inversión.
                </p>
              </div>

              <div className="hidden md:block text-center text-xs text-gray-400 mb-2 leading-relaxed" data-id="element-142" data-mp="1maog74a0mk4a">
                <p data-id="element-143" data-mp="3bpujrnqevq3d">Producto digital – acceso inmediato.</p>
                <p data-id="element-144" data-mp="3bqe1b3c5gcgv">
                  El acceso se envía automáticamente por email luego del pago.
                </p>
                <p data-id="element-145" data-mp="3gmbjlf6z3swa">No se envían productos físicos.</p>
              </div>

              <div className="flex items-center justify-center gap-1.5 text-[9px] md:text-xs text-gray-400" data-id="element-146" data-mp="24eswrfembwje">
                <ShieldCheck className="w-3 h-3 md:w-4 md:h-4" data-id="element-147" data-mp="1zh10yaaurq9x" />
                <span data-id="element-148" data-mp="1uohfys9u5sv3">Compra segura y garantizada</span>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}